import { render } from "./modal-detail-shipment.vue?vue&type=template&id=0077849e&ts=true"
import script from "./modal-detail-shipment.vue?vue&type=script&lang=ts"
export * from "./modal-detail-shipment.vue?vue&type=script&lang=ts"

import "./modal-detail-shipment.vue?vue&type=style&index=0&id=0077849e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__